import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class",
                event_payload: 'export'
            },
            {
                btn_text: '<i class="fas fa-print"></i> Nyomtatás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'print'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        headerFields: [
            {
                name: "siteName",
                label: "Ellátóhely",
                visibility: true,
            },
            {
                name: "synlabSendCode",
                label: "Beküldő kód",
                visibility: true,
            },
            {
                name: "barcode",
                label: "Vonalkód szám",
                visibility: true,
            },
            {
                name: "patientName",
                label: "Név",
                visibility: true,
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
                visibility: true,
            },
            {
                name: "dateOfBirth",
                label: "Születési dátum",
                visibility: true,
                slot_name: "birthdate_format",
            },
            {
                name: "sampleTypeName",
                label: "Mintatípus",
                visibility: true,
            },
            {
                name: "labs",
                label: "Vizsgálatok",
                visibility: true,
                slot_name: "rowBreakAtSemicolon",
            },
            {
                name: "quantity",
                label: "Minta darabszám",
                visibility: true,
            },
        ],
        searchHeaderFields: [
            {
                name: "siteId",
                label: "Ellátóhely",
                formSize: 3,
                formType: "select",
                formRequired: true,
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllCompanySite,
                    formatText: function (val) {
                        return val.siteName;
                    },
                    formatOption: function (val) {
                        return val.siteName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'siteName',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "synlabSendCode",
                label: "Beküldő kód",
                formSize: 3,
                formType: "text",
                formVisible: true
            },
            {
                name: "barcode",
                label: "Vonalkód szám",
                formSize: 3,
                formType: "text",
                formVisible: true
            },
            {
                name: "patientName",
                label: "Név",
                formSize: 3,
                formType: "text",
                formVisible: true
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
                formSize: 3,
                formType: "text",
                formVisible: true
            },
            {
                name: "startDate",
                label: "Dátum",
                formSize: 3,
                formType: "date",
                formVisible: true,
                formRequired: true,
            },
        ]
    }
}
